import { render, staticRenderFns } from "./providerSwitchIdentity.vue?vue&type=template&id=0281b118&scoped=true&"
import script from "./providerSwitchIdentity.vue?vue&type=script&lang=babel&"
export * from "./providerSwitchIdentity.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0281b118",
  null
  
)

export default component.exports